import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const ResolvableServiceForm_ResolvableServiceBaseInterface_Fragment =
  graphql(`
    fragment ResolvableServiceForm_ResolvableServiceBaseInterface_Fragment on ResolvableServiceBaseInterface {
      _id
      codingConfig {
        kind
        strategyId
        ... on CodingConfigManual {
          code
        }
        ...CodeCmp_CodingConfig_Fragment
      }
      code
      label
      title
      content
      statusId
      value {
        priceExcludingVat {
          __typename
          value {
            __typename
            mode
            resolverId
            value
          }
          currencyId {
            __typename
            mode
            resolverId
            value
          }
          ...ResolvableAmountCmp_ResolvableAmount_Fragment
        }
        discountPercentage {
          __typename
          mode
          resolverId
          value
          ...ResolvablePercentCmp_ResolvablePercent_Fragment
        }
        discountAmount {
          __typename
          value {
            __typename
            mode
            resolverId
            value
          }
          currencyId {
            __typename
            mode
            resolverId
            value
          }
          ...ResolvableAmountCmp_ResolvableAmount_Fragment
        }
        vatId {
          __typename
          mode
          resolverId
          value
          ...ResolvableIdCmp_ResolvableId_Fragment
        }
      }
      materialUsages {
        _id
        __typename
        materialId
        quantity {
          value
          unitId
        }
        index
        ...MaterialUsageForm_MaterialUsage_Fragment
      }
      costUsages {
        _id
        __typename
        costId
        quantity {
          value
          unitId
        }
        index
        ...CostUsageForm_CostUsage_Fragment
      }
    }
  `);

export type ResolvableServiceForm_ResolvableServiceBaseInterfaceData = ResultOf<
  typeof ResolvableServiceForm_ResolvableServiceBaseInterface_Fragment
>;

// The form edits a readable value: a service whose amounts are confidential is not editable.
export type ResolvableServiceForm_ResolvableServiceBaseInterface = Omit<
  ResolvableServiceForm_ResolvableServiceBaseInterfaceData,
  'value'
> &
  Readonly<{
    value: NonNullable<
      ResolvableServiceForm_ResolvableServiceBaseInterfaceData['value']
    >;
  }>;
